import '../../libs/jquery-ui.js';
import '../../src/filters';
import {block} from '../../src/block-ui';
import Cookie from 'js-cookie';

window.sortProducts = (type, elem) => {
    if ($(elem).is('.active')) {
        return false;
    }

    Cookie.set('products-sorting', type, {expires: 366, path: '/', secure: false});

    setTimeout(function () {
        location.reload();
    }, 300);

    tracker.track('Каталог товаров => Смена сортировки товаров', {Type: type});
};

var naturalCompare = function (g, h) {
    function f(b, c, a) {
        if (a) {
            for (d = c; (a = f(b, d)), 76 > a && 65 < a; ) ++d;
            return +b.slice(c - 1, d);
        }
        a = m && m.indexOf(b.charAt(c));
        return -1 < a
            ? a + 76
            : ((a = b.charCodeAt(c) || 0), 45 > a || 127 < a)
            ? a
            : 46 > a
            ? 65
            : 48 > a
            ? a - 1
            : 58 > a
            ? a + 18
            : 65 > a
            ? a - 11
            : 91 > a
            ? a + 11
            : 97 > a
            ? a - 37
            : 123 > a
            ? a + 5
            : a - 63;
    }
    var d,
        c,
        b = 1,
        k = 0,
        l = 0,
        m = String.alphabet;
    if ((g += '') != (h += ''))
        for (; b; )
            if (
                ((c = f(g, k++)),
                (b = f(h, l++)),
                76 > c && 76 > b && 66 < c && 66 < b && ((c = f(g, k, k)), (b = f(h, l, (k = d))), (l = d)),
                c != b)
            )
                return c < b ? -1 : 1;
    return 0;
};

function filterSort($btn, isToggled) {
    var $list = $btn.parents('.js-filter-block').find('.js-params-list');
    var items = $list.find('.js-filter-item').get();

    if (!isToggled) {
        // Sort all params alphabetically
        items.sort(function (a, b) {
            return naturalCompare($(a).text().toUpperCase(), $(b).text().toUpperCase());
        });
    } else {
        // Sort all by initial index
        items.sort(function (a, b) {
            return naturalCompare($(a).text().toUpperCase(), $(b).text().toUpperCase());
        });

        // Sort first alphabetically
        var firstItems = items.slice(0, 6);
        var otherItems = items.slice(6);

        firstItems.sort(function (a, b) {
            return naturalCompare($(a).text().toUpperCase(), $(b).text().toUpperCase());
        });

        items = firstItems.concat(otherItems);
    }

    $list.empty();

    $.each(items, function (idx, itm) {
        $list.append(itm);
    });

    return $list;
}

var $allToggles = $('.js-filters-toggle-more');

if ($allToggles.length > 0) {
    // Initial sorting
    $allToggles.each(function () {
        filterSort($(this), true);
    });

    $(document).on('click', '.js-filters-toggle-more', function () {
        var isToggled = $(this).is('.toggled');
        $(this).text(isToggled ? $(this).data('show') : $(this).data('hide'));

        var $list = filterSort($(this), isToggled);

        $list.toggleClass('unlimited', !isToggled);
        $(this).toggleClass('toggled', !isToggled);
    });
}

window.ladParams = link => {
    block();
    location.href = link;
};

window.ladParams2 = (link, param_id) => {
    block();
    var min = $('#minCost' + param_id).val();
    var max = $('#maxCost' + param_id).val();

    link = link.replace('[min]', min);
    link = link.replace('[max]', max);

    setTimeout(function () {
        location.href = link;
    }, 300);

    tracker.track('Каталог товаров => Использование фильтра товаров', {
        link: link,
    });
};

// switcher product
$('a.switcher').on('click', function (e) {
    e.preventDefault();

    var theid = $(this).attr('id');
    var theproducts = $('#products');
    var classNames = $(this).attr('class').split(' ');

    if ($(this).hasClass('active')) {
        // if currently clicked button has the active class
        // then we do nothing!
        return false;
    } else {
        // otherwise we are clicking on the inactive button
        // and in the process of switching views!

        tracker.track('Каталог товаров => Смена типа отображения товаров', {Тип: theid});

        if (theid == 'gridview') {
            $(this).addClass('active');
            $('#listview').removeClass('active');

            $('#listview').children('img').attr('src', '/images/list-view.png');

            var theimg = $(this).children('img');
            theimg.attr('src', '/images/grid-view-active.png');

            $('.like-btn.list').addClass('hidden');
            $('.like-btn.grid').removeClass('hidden');
            $('.price_roznica.list').hide();
            $('.price_roznica.grid').show();

            Cookie.set('products', 'grid', {expires: 366, path: '/', secure: false});

            // remove the list class and change to grid
            theproducts.removeClass('list');
            theproducts.addClass('grid');
        } else if (theid == 'listview') {
            $(this).addClass('active');
            $('#gridview').removeClass('active');

            $('#gridview').children('img').attr('src', '/images/grid-view.png');

            var theimg = $(this).children('img');
            theimg.attr('src', '/images/list-view-active.png');

            $('.like-btn.grid').addClass('hidden');
            $('.like-btn.list').removeClass('hidden');
            $('.price_roznica.list').show();
            $('.price_roznica.grid').hide();

            // remove the grid view and change to list
            theproducts.removeClass('grid');
            theproducts.addClass('list');

            Cookie.set('products', 'list', {expires: 366, path: '/', secure: false});
        }
    }
});
